var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { each, isPrimitive, isValid } from "@al/aku-lc-helpers";
import { buildPath } from "@al/aku-lc-path";
import { get, merge, update } from "lodash";
import { action, makeObservable, observable, autorun, toJS, set, computed } from "mobx";
import { container, ENV_KEY, PUB_SUB } from "../container";
import { isInputOrSelectEvent, getValuesFromEvent } from "../helpers/event";
import { validateRules } from "../helpers/validator";
import { LifeCycleTypes, } from "../types";
import { Query } from "./query";
var EMPTY_ERRORS = [];
var Widget = /** @class */ (function () {
    function Widget(props, app) {
        var _this = this;
        Object.defineProperty(this, "_app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_initialValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_dataSource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_required", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_visible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_hidden", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_disabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_editable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_readOnly", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_component", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_componentProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_decorator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_decoratorProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // widget 路径标识
        Object.defineProperty(this, "_path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_actions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.object({})
        });
        Object.defineProperty(this, "_form", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_isForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "_rowData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_columnValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_columnIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_injectData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_validating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "_errors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.array([])
        });
        Object.defineProperty(this, "_touched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "_pluginData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_fieldName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "reactions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "triggers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "pubSub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rules", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "env", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (props) {
                _this._type = props.type;
                _this._initialValue = props.initialValue;
                _this.value = props.value || props.initialValue;
                _this._dataSource = props.dataSource;
                _this._loading = props.loading;
                _this._required = props.required;
                _this._visible = props.visible;
                _this._hidden = props.hidden;
                _this._disabled = props.disabled;
                _this._editable = props.editable;
                _this._readOnly = props.readOnly;
                _this._component = props.component;
                _this._componentProps = props.componentProps;
                _this._decorator = props.decorator;
                _this._decoratorProps = props.decoratorProps;
                _this.reactions = props.reactions || [];
                _this.triggers = props.triggers || {};
                _this._actions = observable.object(props.actions || {});
                _this._form = props.form;
                _this._isForm = !!props.isForm;
                _this._fieldName = props.fieldName;
                _this._pluginData = props.pluginData;
                _this.rules = props.rules || [];
                _this._rowData = props.rowData;
                _this._columnValue = props.columnValue;
                _this._columnIndex = props.columnIndex;
            }
        });
        Object.defineProperty(this, "makeObservable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                makeObservable(_this, {
                    _value: observable,
                    _initialValue: observable,
                    _dataSource: observable,
                    _required: observable,
                    _loading: observable,
                    _visible: observable,
                    _hidden: observable,
                    _disabled: observable,
                    _editable: observable,
                    _readOnly: observable,
                    _component: observable,
                    _componentProps: observable,
                    _decorator: observable,
                    _decoratorProps: observable,
                    _actions: observable,
                    _injectData: observable,
                    _validating: observable,
                    _touched: observable,
                    _errors: observable,
                    _pluginData: observable,
                    invalid: computed,
                    valid: computed,
                    validateStatus: computed,
                    setBools: action,
                    setValue: action,
                    setInitialValue: action,
                    setDataSource: action,
                    setInjectData: action,
                    setErrors: action,
                    setValidating: action,
                    setTouched: action,
                    setPluginData: action,
                    patchProps: action,
                    updatePayloads: action,
                    updateComponentProps: action,
                    onMount: action,
                    onUnmount: action,
                    onClick: action,
                    onInput: action,
                    onFocus: action,
                    onBlur: action,
                    reset: action,
                });
            }
        });
        Object.defineProperty(this, "makeReactive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.reactions.forEach(function (reactive) {
                    _this.disposers.push(autorun(function () {
                        reactive(_this);
                    }));
                });
            }
        });
        Object.defineProperty(this, "subscribe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                if (_this.isForm) {
                    _this.pubSub.subscribe(LifeCycleTypes.OnFormSubmit, _this.onSubmit);
                }
            }
        });
        Object.defineProperty(this, "setActionsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                // TODO: 需删除之前已存在的 key value
                each(toJS(_this._actions), function (value, key) {
                    var _a;
                    // this._actions.delete(value.path);
                    var p = buildPath("actions/" + value.path, _this.path);
                    value.path = p;
                    set(_this._actions, (_a = {},
                        _a[p] = value,
                        _a));
                });
            }
        });
        Object.defineProperty(this, "callTrackingFunc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (type, extra) {
                var _a, _b, _c, _d, _e, _f;
                if ((_b = (_a = _this.pluginData) === null || _a === void 0 ? void 0 : _a.tracking) === null || _b === void 0 ? void 0 : _b[type]) {
                    (_d = (_c = _this.env.eventTracking) === null || _c === void 0 ? void 0 : _c.report) === null || _d === void 0 ? void 0 : _d.call(_c, type, __assign(__assign({}, toJS((_f = (_e = _this.pluginData) === null || _e === void 0 ? void 0 : _e.tracking) === null || _f === void 0 ? void 0 : _f[type])), extra));
                }
            }
        });
        Object.defineProperty(this, "setBools", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (payload) {
                var key = payload.key, value = payload.value;
                _this[key] = value;
            }
        });
        Object.defineProperty(this, "setValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value) {
                _this.value = value;
            }
        });
        Object.defineProperty(this, "setInitialValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (value) {
                _this._initialValue = value;
            }
        });
        Object.defineProperty(this, "setDataSource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (dataSource) {
                _this._dataSource = dataSource;
            }
        });
        Object.defineProperty(this, "setInjectData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (data) {
                _this._injectData = data;
            }
        });
        Object.defineProperty(this, "setTouched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (v) {
                _this._touched = v;
            }
        });
        Object.defineProperty(this, "setRules", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (rules) {
                _this.rules = rules;
            }
        });
        Object.defineProperty(this, "setPluginData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (data) {
                _this._pluginData = data;
            }
        });
        Object.defineProperty(this, "query", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (fullPath) {
                var _a = String(fullPath).split(/\s*\$\s*/), path = _a[0], subPath = _a[1];
                return new Query(path, subPath);
            }
        });
        Object.defineProperty(this, "patchProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (props) {
                Object.keys(props).forEach(function (k) {
                    var _a, _b;
                    // @ts-expect-error 1111
                    var value = props[k];
                    if (isValid(value)) {
                        // @ts-expect-error 1111
                        _this["_" + k] = value;
                        if (_this.isForm) {
                            if (k === "initialValue") {
                                (_a = _this.form) === null || _a === void 0 ? void 0 : _a.setInitialValue(value);
                            }
                            else if (k === "value") {
                                (_b = _this.form) === null || _b === void 0 ? void 0 : _b.setValue(value);
                            }
                        }
                    }
                });
            }
        });
        Object.defineProperty(this, "setTriggers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (triggers) {
                _this.triggers = triggers;
            }
        });
        Object.defineProperty(this, "setErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (errors) {
                _this._errors = errors;
            }
        });
        Object.defineProperty(this, "setValidating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (v) {
                _this._validating = v;
            }
        });
        Object.defineProperty(this, "updatePayloads", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (payloads) {
                each(payloads, function (value, key) {
                    var p = buildPath("actions/" + key, _this.path);
                    if (_this._actions[p]) {
                        _this._actions[p].updatePayload(value);
                    }
                });
            }
        });
        Object.defineProperty(this, "updateComponentProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (key, props) {
                if (!isPrimitive(props)) {
                    update(_this.componentProps, key, function () {
                        return merge(toJS(get(_this.componentProps, key)), props);
                    });
                }
                else {
                    update(_this.componentProps, key, function () { return props; });
                }
            }
        });
        Object.defineProperty(this, "validate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (triggerType, customValidator) { return __awaiter(_this, void 0, void 0, function () {
                var filterRules;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setValidating(true);
                            filterRules = this.rules.filter(function (rule) {
                                // 规则默认在 onInput 时校验
                                if (!rule.validateTrigger && triggerType === "onInput") {
                                    return rule;
                                }
                                if (triggerType) {
                                    return rule.validateTrigger === triggerType;
                                }
                                return rule;
                            });
                            if (customValidator) {
                                // @ts-expect-error custom validator
                                filterRules.push(customValidator);
                            }
                            // 隐藏的字段跳过校验
                            if (!filterRules.length || this._visible === false || this._hidden) {
                                this.setValidating(false);
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, validateRules({
                                    name: this.path,
                                    value: this.value,
                                    rules: filterRules,
                                    validateFirst: false,
                                })
                                    .catch(function (e) { return e; })
                                    .then(function (ruleErrors) {
                                    if (ruleErrors === void 0) { ruleErrors = EMPTY_ERRORS; }
                                    var errors = [];
                                    ruleErrors.forEach(function (ruleError) {
                                        errors.push.apply(errors, ruleError.errors);
                                    });
                                    _this.setErrors(errors);
                                })];
                        case 1:
                            _a.sent();
                            this.setValidating(false);
                            return [2 /*return*/];
                    }
                });
            }); }
        });
        Object.defineProperty(this, "onMount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a, _b;
                _this.callTrackingFunc("enter");
                (_b = (_a = _this.triggers).onMount) === null || _b === void 0 ? void 0 : _b.call(_a, _this);
            }
        });
        Object.defineProperty(this, "onUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a, _b;
                _this.callTrackingFunc("leave");
                (_b = (_a = _this.triggers).onUnmount) === null || _b === void 0 ? void 0 : _b.call(_a, _this);
            }
        });
        Object.defineProperty(this, "onSubmit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(_this, void 0, void 0, function () {
                    var error_1;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, ((_b = (_a = this.triggers).onSubmit) === null || _b === void 0 ? void 0 : _b.call(_a, this, { data: args[0] || {} }))];
                            case 1:
                                _c.sent();
                                this.pubSub.publishSync(LifeCycleTypes.OnFormSubmitSuccess, { formPath: this.path });
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _c.sent();
                                this.pubSub.publishSync(LifeCycleTypes.OnFormSubmitFailed, { formPath: this.path });
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "onInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(_this, void 0, void 0, function () {
                    var values, value;
                    var _a, _b, _c, _d;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0:
                                if ((_a = args[0]) === null || _a === void 0 ? void 0 : _a.target) {
                                    if (!isInputOrSelectEvent(args[0])) {
                                        return [2 /*return*/];
                                    }
                                }
                                values = getValuesFromEvent(args);
                                value = values[0];
                                this.setTouched(true);
                                (_b = this._form) === null || _b === void 0 ? void 0 : _b.setTouched(true);
                                (_d = (_c = this.triggers).onChange) === null || _d === void 0 ? void 0 : _d.call.apply(_d, __spreadArray([_c, this, value], args));
                                this.setValue(value);
                                this.callTrackingFunc("input", {
                                    // eslint-disable-next-line @typescript-eslint/naming-convention
                                    __componentValue: value,
                                });
                                return [4 /*yield*/, this.validate("onInput")];
                            case 1:
                                _e.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "onFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(_this, void 0, void 0, function () {
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                (_b = (_a = this.triggers).onFocus) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a, this], args));
                                return [4 /*yield*/, this.validate("onFocus")];
                            case 1:
                                _c.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "onBlur", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(_this, void 0, void 0, function () {
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                (_b = (_a = this.triggers).onBlur) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a, this], args));
                                return [4 /*yield*/, this.validate("onBlur")];
                            case 1:
                                _c.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "onClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a, _b;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.callTrackingFunc("click");
                (_b = (_a = _this.triggers).onClick) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a, _this], args));
            }
        });
        Object.defineProperty(this, "onPoppedConfirm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(_this, void 0, void 0, function () {
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                this.callTrackingFunc("click");
                                return [4 /*yield*/, ((_b = (_a = this.triggers).onPoppedConfirm) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a, this], args)))];
                            case 1:
                                _c.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "onPoppedCancel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(_this, void 0, void 0, function () {
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                this.callTrackingFunc("click");
                                return [4 /*yield*/, ((_b = (_a = this.triggers).onPoppedCancel) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a, this], args)))];
                            case 1:
                                _c.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "executeAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (actionPath) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                return __awaiter(_this, void 0, void 0, function () {
                    var action;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                action = this._actions[actionPath];
                                if (!action) return [3 /*break*/, 2];
                                return [4 /*yield*/, action.execute.apply(action, args)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                });
            }
        });
        Object.defineProperty(this, "reset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (options) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setTouched(false);
                            this.setErrors([]);
                            if (options === null || options === void 0 ? void 0 : options.forceClear) {
                                this.setValue(undefined);
                            }
                            else {
                                this.setValue(toJS(this.initialValue));
                            }
                            if (!(options === null || options === void 0 ? void 0 : options.validate)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.validate()];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2: return [2 /*return*/];
                    }
                });
            }); }
        });
        Object.defineProperty(this, "dispose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.disposers.forEach(function (disposer) {
                    disposer();
                });
            }
        });
        this._app = app;
        this._path = props.path;
        this.pubSub = container.resolve(PUB_SUB);
        this.env = container.resolve(ENV_KEY);
        this.initialize(props);
        this.setActionsPath();
        this.makeObservable();
        this.makeReactive();
        this.subscribe();
    }
    Object.defineProperty(Widget.prototype, "app", {
        get: function () {
            return this._app;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (v) {
            var _a;
            this._value = v;
            (_a = this._form) === null || _a === void 0 ? void 0 : _a.setValueIn(this.path, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "initialValue", {
        get: function () {
            return this._initialValue;
        },
        set: function (v) {
            var _a;
            (_a = this._form) === null || _a === void 0 ? void 0 : _a.setInitialValueIn(this.path, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "dataSource", {
        get: function () {
            return this._dataSource;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "required", {
        get: function () {
            return this._required;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "hidden", {
        get: function () {
            return this._hidden;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "editable", {
        get: function () {
            return this._editable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "readOnly", {
        get: function () {
            return this._readOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "component", {
        get: function () {
            return this._component;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "componentProps", {
        get: function () {
            return this._componentProps;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "decorator", {
        get: function () {
            return this._decorator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "decoratorProps", {
        get: function () {
            return this._decoratorProps;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "path", {
        get: function () {
            return this._path;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "actions", {
        get: function () {
            return this._actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "form", {
        get: function () {
            return this._form;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "isForm", {
        get: function () {
            return this._isForm;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "rowData", {
        get: function () {
            return this._rowData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "columnValue", {
        get: function () {
            return this._columnValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "columnIndex", {
        get: function () {
            return this._columnIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "injectData", {
        get: function () {
            return this._injectData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "validating", {
        get: function () {
            return this._validating;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "valid", {
        get: function () {
            return !this.errors.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "invalid", {
        get: function () {
            return !this.valid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "errors", {
        get: function () {
            return this._errors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "validateStatus", {
        get: function () {
            if (this.validating) {
                return "validating";
            }
            if (this.invalid) {
                return "error";
            }
            if (this.valid) {
                return "success";
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "touched", {
        get: function () {
            return this._touched;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "pluginData", {
        get: function () {
            return this._pluginData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "fieldName", {
        get: function () {
            return this._fieldName;
        },
        enumerable: false,
        configurable: true
    });
    return Widget;
}());
export { Widget };
